<script setup lang="ts">
import CmsDataProvider, { CMS_DATA_ID } from "@/providers/cms.provider";
import WidgetColors from './components/WidgetColors.vue';

const cmsData = CmsDataProvider.get<{
  ctaButtonText?: string
}>(CMS_DATA_ID.ACTIVITEITEN_WIDGET);

const openWidget = () => {
    sendMessage('sportmatch-widget-open')
}

const sendMessage = (message: string) => {
    window.top?.postMessage(message, '*')
}
</script>
<template>
      <WidgetColors />
        <button class="sportmatch-widget-cta btn btn-cta-widget" @click="openWidget" aria-label="Open Sportmatch widget">
            <span class="icon icon-agenda" aria-hidden="true"></span>
            {{cmsData.ctaButtonText ?? 'Boek jouw activiteit'}}
        </button>
</template>